import { useContext } from "react";
import MaskService from "../../../../utils/mask/maskService";
import { notify } from "../../../../utils/notify";
import { validNotNull } from "../../../../utils/validations";
import { EmissaoContext } from "../contexts/EmissaoContext";
import { GlobalVariables } from "../../../../GlobalVariables";
import { QueryParamsContext } from "../../../../context/QueryParamsContext";
import moment from "moment";

export default function useRulesEmissaoSubmit() {
  const {
    headerTypeNfe,
    headerOperationNature,
    headerCfop,
    headerFinalCostumer,
    headerOperation,
    headerPresentOperation,
    headerFinnally,
    headerTime,
    headerDateJL,
    headerIndicatorIntermed,
    headerReasonIntermed,
    headerIdentifierIntermed,
    headerIntermedCnpj,
    senderName,
    senderAddress,
    senderCity,
    senderNumber,
    senderUf,
    senderUfLabel,
    senderIndicationIe,
    senderIe,
    itensTotalProductValue,
    itensTotalNfe,
    itensTotalValueIcms,
    itensTotalBaseIcms,
    itensTotalBaseSt,
    itensTotalValueSt,
    itensTotalValueIpi,
    itensTotalValuePis,
    itensTotalValueCofins,
    itensTotalValueII,
    itensTotalOthers,
    senderCheckBilling,
    senderBillingAddress,
    senderBillingNumber,
    senderBillingUf,
    senderBillingCity,
    senderCheckDelivery,
    senderDeliveryAddress,
    senderDeliveryNumber,
    senderDeliveryUf,
    senderDeliveryCity,
    itensTotal,
    transpModality,
    nfeMontageType,
    pagtoTableCobranca,
    pagtoTableFormaPagto,
    itensTable,
    headerIssueType,
    transpName,
    transpCity,
    nfeMontageSubtype,
    transpCnpj,
    senderCnpj,
    xmlAuthorizedList,
    headerSeries,
    headerModel,
  } = useContext(EmissaoContext);

  const { queryParams } = useContext(QueryParamsContext);

  const rmd = (value) => {
    return MaskService.removeMaskDecimal(value || "0,00");
  };

  const validHeader = () => {
    const validate = [
      {
        key: "headerTypeNfe",
        value: headerTypeNfe,
      },
      {
        key: "headerOperationNature",
        value: headerOperationNature,
      },
      {
        key: "headerCfop",
        value: headerCfop,
      },
      {
        key: "headerFinalCostumer",
        value: headerFinalCostumer,
      },
      {
        key: "headerOperation",
        value: headerOperation,
      },
      {
        key: "headerPresentOperation",
        value: headerPresentOperation,
      },
      {
        key: "headerFinnally",
        value: headerFinnally,
      },
      {
        key: "headerTime",
        value: headerTime,
      },
      {
        key: "headerDateJL",
        value: headerDateJL,
      },
      {
        key: "headerSeries",
        value: headerSeries,
      },
    ];

    if (
      [
        GlobalVariables.nfe.inPersonOperationsTypes.notInPersonOnCallCenter,
        GlobalVariables.nfe.inPersonOperationsTypes.notInPersonOnInternet,
        GlobalVariables.nfe.inPersonOperationsTypes.notInPersonOthers,
      ].includes(headerPresentOperation?.value)
    ) {
      validate.push({
        key: "headerIndicatorIntermed",
        value: headerIndicatorIntermed,
      });

      if (headerIndicatorIntermed?.value === "1") {
        validate.push({
          key: "headerReasonIntermed",
          value: headerReasonIntermed,
        });
        validate.push({
          key: "headerIdentifierIntermed",
          value: headerIdentifierIntermed,
        });
        validate.push({
          key: "headerIntermedCnpj",
          value: headerIntermedCnpj,
        });
      }
    }

    if (
      headerCfop &&
      parseInt(parseInt(headerCfop) / 1000) !== 6 &&
      parseInt(parseInt(headerCfop) / 1000) !== 2 &&
      headerOperation?.value === GlobalVariables.nfe.operations.interstate
    ) {
      return notify("Cfop Inválido para a Operação Interestadual");
    }

    if (!headerIssueType) {
      return notify("Tipo de Emissao não configurado.");
    }

    return validNotNull(validate);
  };

  const validReceiver = () => {
    if (headerModel?.value === GlobalVariables.nfeModel.nfce)
      return validNotNull([]);

    const validate = [
      {
        key: "senderName",
        value: senderName,
      },
      {
        key: "senderAddress",
        value: senderAddress,
      },
      {
        key: "senderCity",
        value: senderCity,
      },
      {
        key: "senderNumber",
        value: senderNumber,
      },
      {
        key: "senderUf",
        value: senderUf,
      },
      {
        key: "senderUfLabel",
        value: senderUfLabel,
      },
      {
        key: "senderIndicationIe",
        value: senderIndicationIe,
      },
    ];

    if (senderIndicationIe?.codigo === "1") {
      validate.push({
        key: "senderIe",
        value: senderIe,
      });
    }

    if (senderCheckBilling) {
      validate.push(
        {
          key: "senderBillingAddress",
          value: senderBillingAddress,
        },
        {
          key: "senderBillingNumber",
          value: senderBillingNumber,
        },
        {
          key: "senderBillingUf",
          value: senderBillingUf,
        },
        {
          key: "senderBillingCity",
          value: senderBillingCity,
        }
      );
    }

    if (senderCheckDelivery) {
      validate.push(
        {
          key: "senderDeliveryAddress",
          value: senderDeliveryAddress,
        },
        {
          key: "senderDeliveryNumber",
          value: senderDeliveryNumber,
        },
        {
          key: "senderDeliveryUf",
          value: senderDeliveryUf,
        },
        {
          key: "senderDeliveryCity",
          value: senderDeliveryCity,
        }
      );
    }

    return validNotNull(validate);
  };

  const validTotals = () => {
    const validate = validNotNull([
      {
        key: "itensTotalProductValue",
        value: itensTotalProductValue,
      },
      {
        key: "itensTotalNfe",
        value: itensTotalNfe,
      },

      {
        key: "itensTotalValueIcms",
        value: itensTotalValueIcms,
      },
      {
        key: "itensTotalBaseIcms",
        value: itensTotalBaseIcms,
      },
      {
        key: "itensTotalBaseSt",
        value: itensTotalBaseSt,
      },
      {
        key: "itensTotalValueSt",
        value: itensTotalValueSt,
      },
      {
        key: "itensTotalValueIpi",
        value: itensTotalValueIpi,
      },
      {
        key: "itensTotalValuePis",
        value: itensTotalValuePis,
      },
      {
        key: "itensTotalValueCofins",
        value: itensTotalValueCofins,
      },
      {
        key: "itensTotalValueII",
        value: itensTotalValueII,
      },
      {
        key: "itensTotalOthers",
        value: itensTotalOthers,
      },
    ]);

    if (
      !rmd(itensTotalNfe) &&
      headerFinnally.value !== GlobalVariables.nfe.purpose.additionalNfe
    ) {
      validate.errorsValidation.itensTotalNfe = true;
      validate.error = true;
    }

    if (
      !rmd(itensTotalProductValue) &&
      headerFinnally.value !== GlobalVariables.nfe.purpose.additionalNfe
    ) {
      validate.errorsValidation.itensTotalProductValue = true;
      validate.error = true;
    }

    if (!parseInt(itensTotal)) {
      validate.errorsValidation.itensTotal = true;
    }

    return validate;
  };

  const validOthers = () => {
    return validNotNull([
      {
        key: "transpModality",
        value: transpModality,
      },
    ]);
  };

  const validXmlAuthorized = (additionalDocument = null) => {
    const copyXmlAuthorizedList = [...xmlAuthorizedList];
    if (additionalDocument) {
      copyXmlAuthorizedList.push({ documento: additionalDocument });
    }

    const validateDocuments = [
      {
        value: transpCnpj,
        type: "da transportadora",
      },
      {
        value: senderCnpj,
        type: "do destinatário",
      },
      {
        value: queryParams.empresa_cnpj,
        type: "do emitente",
      },
      {
        value: headerIndicatorIntermed?.value === "1" ? headerIntermedCnpj : "",
        type: "do intermediário",
      },
    ];

    let validationXmlAuthorized = { isValid: true, message: "" };
    validateDocuments.forEach((document) => {
      if (copyXmlAuthorizedList.find((e) => e.documento === document.value)) {
        validationXmlAuthorized.message = `CPF/CNPJ ${document.type} não pode estar presente na lista de autorizados XML.`;
        validationXmlAuthorized.isValid = false;
      }
    });
    return validationXmlAuthorized;
  };

  const validPayment = () => {
    let totalCobranca = 0;
    pagtoTableCobranca.forEach((value) => {
      totalCobranca += rmd(value.cobrancaValor);
    });

    let totalPagamento = 0;
    let noPayment = false;
    let noPaymentCfop = false;
    pagtoTableFormaPagto.forEach((value) => {
      totalPagamento += rmd(value.pagtoValor);
      if (value.pagtoFormaValue === "90") noPayment = true;
    });

    if (noPayment && pagtoTableCobranca.length) {
      return notify(
        `Cobrança Não pode Ser Informada Caso a Forma de Pagmento Selecionada seja "Sem Pagamento"`
      );
    }

    if (
      pagtoTableCobranca.length &&
      parseFloat(totalCobranca.toFixed(2)) < rmd(itensTotalNfe)
    ) {
      noPaymentCfop = true;
      notify(
        "Total da Condição de Pagamento inferior ao valor total da Nota.",
        true,
        "warning"
      );
    }

    if (
      parseFloat(totalPagamento.toFixed(2)) !== rmd(itensTotalNfe) &&
      headerTypeNfe?.value === "S" &&
      !noPayment &&
      !noPaymentCfop &&
      nfeMontageSubtype !== "D"
    ) {
      notify(
        "Total do Pagamento não bate com o valor total da Nota.",
        true,
        "warning"
      );
    }

    if (
      nfeMontageType === "A" &&
      !pagtoTableCobranca.length &&
      headerTypeNfe?.value === "S" &&
      nfeMontageSubtype !== "D" &&
      pagtoTableFormaPagto[0]?.pagtoFormaValue !== "90"
    ) {
      return notify(
        "A Condição de Pagamento deve ser informada caso a nota tenha sido gerada a partir de um pedido com Títulos já Liquidados."
      );
    }

    // verifica se todas as datas cobrancaDtVenctoValue são iguais a headerDateJL
    const someDateAfter = pagtoTableCobranca.some((charge) =>
      moment(charge?.cobrancaDtVenctoValue).isAfter(moment(headerDateJL))
    );

    if (someDateAfter) {
      const hasCashPayment = pagtoTableFormaPagto.some(
        (payment) => payment.pagtoIndicadorValue === "0"
      );

      if (hasCashPayment) {
        return notify(
          "Não é permitido selecionar pagamento à vista quando as datas de vencimento forem futuras à data de emissão da nota fiscal."
        );
      }
    }

    if (!pagtoTableCobranca?.length) {
      const hasInstallmentPayments = pagtoTableFormaPagto.some(
        (payment) => payment.pagtoIndicadorValue === "1"
      );

      if (hasInstallmentPayments) {
        return notify(
          "Não é permitido selecionar pagamento à prazo quando não há cobranças informadas."
        );
      }
    }

    return true;
  };

  const validItens = () => {
    let valid = true;
    itensTable.forEach((row) => {
      if (!row.prodIcmsSituacao?.value) {
        valid = false;
        return notify(
          "Produto: " +
            row.prodDescricao +
            " Não possui Tributação de ICMS Selecionada."
        );
      }

      if (!row.prodPisSituacao?.value) {
        valid = false;
        return notify(
          "Produto: " +
            row.prodDescricao +
            " Não possui Tributação de PIS Selecionada."
        );
      }

      if (!row.prodCofinsSituacao?.value) {
        valid = false;
        return notify(
          "Produto: " +
            row.prodDescricao +
            " Não possui Tributação de COFINS Selecionada."
        );
      }
    });

    return valid;
  };

  const validShippingCompany = () => {
    const codeRules = {
      0: false,
      1: false,
      2: false,
      3: true,
      4: true,
      9: false,
    };

    if (codeRules[transpModality?.value] && !transpName) {
      return notify("Selecione uma Transportadora para a modalidade indicada");
    }

    if ((codeRules[transpModality?.value] || transpName) && !transpCity) {
      return notify("Selecione o município da transportadora");
    }

    return true;
  };

  return {
    validHeader,
    validReceiver,
    validTotals,
    validOthers,
    validPayment,
    validItens,
    validShippingCompany,
    validXmlAuthorized,
  };
}
